import { createContext } from "react";
import { TourContextType } from "./tour.typings";


export const TourContext = createContext<TourContextType>({
    height: 0,
    width: 0,
    devicePixelRatio,
    displayStyles: {
        backdropColor: "",
        backdropOpacity: 0.6,
        cornerRadius: 0,
        borderWidth: 0,
        borderColor: "",
        padding: 0,
        transitionDuration: 0.2
    }
})